import axios from "axios";

export const lookupUserByEmail = async (email) => {
    return axios
        .get("admin/user/lookup", { params: { email } })
        .then((response) => {
            return response.data.result || [];
        })
        .catch((error) => {
            console.error("Failed to get user access by email");
            console.error(error);
            return [];
        });
};
